// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bracket {
  display: flex;
  justify-content: spce-between;
  width: 1366px;
  align-items: center;
}

.column {
  display: flex;
  flex-direction: column;
  margin-top: 0px;
}

.column2 {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-right: 5px;
}

.column3 {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-right: 5px;
}

.column4 {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 112px;
}

.bracket-game-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* CSS for the user selection row */
.user-selection-row {
  display: flex; /* Display items in a row */
  align-items: center; /* Align items vertically in the center */
  margin-bottom: 10px; /* Add some spacing between rows */
  width: 100%;
}

/* Style the text inside the user selection row */
.user-selection-row div {
  font-size: 24px; /* Set the font size to make it bigger */
  font-weight: bold; /* Make the text bold */
}

/* Style the selection box (dropdown) */
.user-selection-row select {
  font-size: 16px; /* Adjust the font size of the dropdown options */
  padding: 8px; /* Add padding to increase the size of the dropdown box */
  border-radius: 5px; /* Add border radius for rounded corners */
  border: 1px solid #ccc; /* Add border for visual distinction */
}

.user-selection-row select,
.user-selection-row input[type=text] {
  margin-right: 100px; /* Add some spacing between input elements */
}

.region-names {
  width: 187px;
  height: 36px;
  flex-shrink: 0;
  color: #CECECE; /* Text color */
  text-align: center; /* Center-align text */
  font-family: Inter; /* Font family */
  font-size: 50px; /* Font size */
  font-style: normal; /* Font style */
  font-weight: 700; /* Font weight */
  line-height: normal; /* Line height */
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 50px;
}

.tiebreaker-box {
  border: 1px solid #000; /* Add border style */
  padding: 10px; /* Add padding for spacing */
  border-radius: 8px;
}

.top-row {
  font-weight: bold; /* Make the text bold */
  text-align: center; /* Center the text */
  margin-bottom: 5px; /* Add margin for spacing between rows */
  font-family: Inter;
  font-size: 24px;
}

.bottom-row {
  font-weight: bold; /* Make the text bold */
  text-align: center; /* Center the text */
  margin-bottom: 5px; /* Add margin for spacing between rows */
  font-family: Inter;
  font-size: 18px;
}

.champion-container {
  position: relative;
  width: 123px; /* Adjust the width based on content */
  align-items: center;
  margin-left: 50px;
}

.top-box {
  height: 84px;
  top: 48px;
  left: 213px;
  border: 2px solid rgba(0, 0, 0, 0.2509803922); /* Add default border color */
  border-radius: 8px 8px 0 0; /* Add border radius */
  display: flex;
  justify-content: center; /* Center content horizontally */
  align-items: center; /* Center content vertically */
  background-color: #ffffff; /* Add background color */
  border-color: rgba(0, 0, 0, 0.2509803922);
}

.bottom-box {
  height: 29.4px;
  top: 149.6px;
  left: 197px;
  border-radius: 0 0 8px 8px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.2509803922);
}

.text-row-container {
  height: auto; /* Adjusted to accommodate variable content */
  text-align: center;
  display: flex; /* Enable flexbox */
  align-items: center; /* Center content vertically */
  justify-content: center; /* Center content horizontally */
}

.text-row {
  text-align: center;
  color: rgb(0, 0, 0);
}

.text-row-img {
  max-height: 16px; /* Set a maximum height for the image */
  margin-right: 5px; /* Add spacing between the image and text */
}

.null-champ {
  width: 75%;
  height: 75%;
  background-color: rgba(0, 0, 0, 0.2509803922); /* Gray background color */
  border: 2px solid rgba(0, 0, 0, 0.2509803922); /* Gray border */
  border-radius: 8px; /* Border radius */
  box-sizing: border-box; /* Include border in width and height */
  padding: 25px; /* Add padding to create space between border and content */
}

.champ-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.crown-logo {
  width: 135px;
  height: 56px;
  flex-shrink: 0;
  fill: #EDEDED;
  stroke-width: 1px;
  stroke: #6D6D6D;
  justify-content: center;
  margin-left: 44px;
  margin-bottom: 5px;
}

.bracket-game-container {
  width: 185px;
  height: 123px;
}

.bracketBox {
  border: 1px solid #002129;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.3764705882);
  width: 184px;
  height: 78px;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 2px;
}

.row-text {
  margin-bottom: 8px;
  font-size: 16px;
}

.bottom-text {
  margin-top: 8px;
  font-size: 16px;
}

.team-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.team-name {
  flex: 1 1;
  font-size: 16px;
}

/* Score container */
.team-score-container {
  flex-shrink: 0; /* Prevents the score container from stretching */
}

.team-score {
  font-size: 12px;
}

/* Bracket team container */
.bracket-team-container {
  display: flex;
  width: 146px;
  align-items: center;
  gap: var(--1, 8px);
  border-radius: var(--1, 8px);
  background: #FFF;
}

/* Team logo */
.team-logo-svg {
  width: 16px;
  height: 16px;
  fill: #EDEDED;
  margin-right: 10px;
}

/* Team seed */
.team-seed {
  width: 14px;
  height: 15px;
  color: #002129;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-right: 10px;
}

/* Team name */
.team-name {
  width: 87px;
  height: 15px;
  color: #002129;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.no-team-name {
  width: 135px;
  height: 12px;
  fill: #D9D9D9;
}`, "",{"version":3,"sources":["webpack://./src/components/bracketEvents/bracketEvents/BracketBox.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EAEA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EAEA,gBAAA;EACA,iBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAFF;;AAMA,mCAAA;AACA;EACE,aAAA,EAAA,2BAAA;EACA,mBAAA,EAAA,yCAAA;EACA,mBAAA,EAAA,kCAAA;EACA,WAAA;AAHF;;AAMA,iDAAA;AACA;EACE,eAAA,EAAA,wCAAA;EACA,iBAAA,EAAA,uBAAA;AAHF;;AAMA,uCAAA;AACA;EACE,eAAA,EAAA,iDAAA;EACA,YAAA,EAAA,yDAAA;EACA,kBAAA,EAAA,0CAAA;EACA,sBAAA,EAAA,sCAAA;AAHF;;AAMA;;EAEE,mBAAA,EAAA,4CAAA;AAHF;;AAMA;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA,EAAA,eAAA;EACA,kBAAA,EAAA,sBAAA;EACA,kBAAA,EAAA,gBAAA;EACA,eAAA,EAAA,cAAA;EACA,kBAAA,EAAA,eAAA;EACA,gBAAA,EAAA,gBAAA;EACA,mBAAA,EAAA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,sBAAA,EAAA,qBAAA;EACA,aAAA,EAAA,4BAAA;EACA,kBAAA;AAHF;;AAMA;EACE,iBAAA,EAAA,uBAAA;EACA,kBAAA,EAAA,oBAAA;EACA,kBAAA,EAAA,wCAAA;EACA,kBAAA;EACA,eAAA;AAHF;;AAMA;EACE,iBAAA,EAAA,uBAAA;EACA,kBAAA,EAAA,oBAAA;EACA,kBAAA,EAAA,wCAAA;EACA,kBAAA;EACA,eAAA;AAHF;;AAUA;EACE,kBAAA;EACA,YAAA,EAAA,sCAAA;EACA,mBAAA;EACA,iBAAA;AAPF;;AAUA;EACE,YAAA;EACA,SAAA;EACA,WAAA;EACA,6CAAA,EAAA,6BAAA;EACA,0BAAA,EAAA,sBAAA;EACA,aAAA;EACA,uBAAA,EAAA,gCAAA;EACA,mBAAA,EAAA,8BAAA;EACA,yBAAA,EAAA,yBAAA;EACA,yCAAA;AAPF;;AAUA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;AAPF;;AAWA;EACE,YAAA,EAAA,6CAAA;EACA,kBAAA;EACA,aAAA,EAAA,mBAAA;EACA,mBAAA,EAAA,8BAAA;EACA,uBAAA,EAAA,gCAAA;AARF;;AAYA;EACE,kBAAA;EACA,mBAAA;AATF;;AAYA;EACE,gBAAA,EAAA,uCAAA;EACA,iBAAA,EAAA,2CAAA;AATF;;AAYA;EACE,UAAA;EACA,WAAA;EACA,6CAAA,EAAA,0BAAA;EACA,6CAAA,EAAA,gBAAA;EACA,kBAAA,EAAA,kBAAA;EACA,sBAAA,EAAA,uCAAA;EACA,aAAA,EAAA,2DAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AATF;;AAaA;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,YAAA;EACA,aAAA;AAVF;;AAaA;EAQI,yBAAA;EACC,gBAAA;EACA,uDAAA;EACC,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAjBN;;AAoBE;EACE,kBAAA;EACA,eAAA;AAjBJ;;AAoBE;EACE,eAAA;EACA,eAAA;AAjBJ;;AAqBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAlBJ;;AAqBE;EACE,SAAA;EACA,eAAA;AAlBJ;;AAqBE,oBAAA;AACF;EACE,cAAA,EAAA,iDAAA;AAlBF;;AAqBA;EACE,eAAA;AAlBF;;AAsBE,2BAAA;AACF;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;AAnBJ;;AAsBE,cAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAnBJ;;AAsBE,cAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAnBJ;;AAsBE,cAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAnBJ;;AAsBE;EACE,YAAA;EACA,YAAA;EACA,aAAA;AAnBJ","sourcesContent":[".bracket {\n  display: flex;\n  justify-content: spce-between;\n  width: 1366px;\n  align-items: center;\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  margin-top: 0px;\n}\n\n.column2 {\n  display: flex;\n  flex-direction: column;\n  // margin-top: 122px;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n.column3 {\n  display: flex;\n  flex-direction: column;\n  // margin-top: 285px;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n.column4 {\n  display: flex;\n  flex-direction: column;\n  // margin-top: 73px;\n  margin-left: 5px;\n  margin-right: 5px;\n  margin-bottom: 112px;\n}\n\n.bracket-game-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n\n/* CSS for the user selection row */\n.user-selection-row {\n  display: flex; /* Display items in a row */\n  align-items: center; /* Align items vertically in the center */\n  margin-bottom: 10px; /* Add some spacing between rows */\n  width: 100%;\n}\n\n/* Style the text inside the user selection row */\n.user-selection-row div {\n  font-size: 24px; /* Set the font size to make it bigger */\n  font-weight: bold; /* Make the text bold */\n}\n\n/* Style the selection box (dropdown) */\n.user-selection-row select {\n  font-size: 16px; /* Adjust the font size of the dropdown options */\n  padding: 8px; /* Add padding to increase the size of the dropdown box */\n  border-radius: 5px; /* Add border radius for rounded corners */\n  border: 1px solid #ccc; /* Add border for visual distinction */\n}\n\n.user-selection-row select,\n.user-selection-row input[type=\"text\"] {\n  margin-right: 100px; /* Add some spacing between input elements */\n}\n\n.region-names {\n  width: 187px;\n  height: 36px;\n  flex-shrink: 0;\n  color: #CECECE; /* Text color */\n  text-align: center; /* Center-align text */\n  font-family: Inter; /* Font family */\n  font-size: 50px; /* Font size */\n  font-style: normal; /* Font style */\n  font-weight: 700; /* Font weight */\n  line-height: normal; /* Line height */\n  padding: 10px;\n  box-sizing: border-box;\n  margin-bottom: 50px;\n}\n\n.tiebreaker-box {\n  border: 1px solid #000; /* Add border style */\n  padding: 10px; /* Add padding for spacing */\n  border-radius: 8px;\n}\n\n.top-row {\n  font-weight: bold; /* Make the text bold */\n  text-align: center; /* Center the text */\n  margin-bottom: 5px; /* Add margin for spacing between rows */\n  font-family: Inter;\n  font-size: 24px;\n}\n\n.bottom-row {\n  font-weight: bold; /* Make the text bold */\n  text-align: center; /* Center the text */\n  margin-bottom: 5px; /* Add margin for spacing between rows */\n  font-family: Inter;\n  font-size: 18px;\n}\n\n\n\n\n\n.champion-container {\n  position: relative;\n  width: 123px; /* Adjust the width based on content */\n  align-items: center;\n  margin-left: 50px;\n}\n\n.top-box {\n  height: 84px;\n  top: 48px;\n  left: 213px;\n  border: 2px solid #00000040; /* Add default border color */\n  border-radius: 8px 8px 0 0; /* Add border radius */\n  display: flex;\n  justify-content: center; /* Center content horizontally */\n  align-items: center; /* Center content vertically */\n  background-color: #ffffff; /* Add background color */\n  border-color: #00000040;\n}\n\n.bottom-box {\n  height: 29.4px;\n  top: 149.6px;\n  left: 197px;\n  border-radius: 0 0 8px 8px;\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgb(0, 0, 0);\n  background-color: #00000040;\n}\n\n\n.text-row-container{\n  height: auto; /* Adjusted to accommodate variable content */\n  text-align: center;\n  display: flex; /* Enable flexbox */\n  align-items: center; /* Center content vertically */\n  justify-content: center; /* Center content horizontally */\n\n}\n\n.text-row {\n  text-align: center;\n  color: rgb(0, 0, 0);\n}\n\n.text-row-img {\n  max-height: 16px; /* Set a maximum height for the image */\n  margin-right: 5px; /* Add spacing between the image and text */\n}\n\n.null-champ {\n  width: 75%;\n  height: 75%;\n  background-color: #00000040; /* Gray background color */\n  border: 2px solid #00000040; /* Gray border */\n  border-radius: 8px; /* Border radius */\n  box-sizing: border-box; /* Include border in width and height */\n  padding: 25px; /* Add padding to create space between border and content */\n}\n\n.champ-logo {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n\n.crown-logo {\n  width: 135px;\n  height: 56px;\n  flex-shrink: 0;\n  fill: #EDEDED;\n  stroke-width: 1px;\n  stroke: #6D6D6D;\n  justify-content: center;\n  margin-left: 44px;\n  margin-bottom: 5px;\n}\n\n.bracket-game-container {\n  width: 185px;\n  height: 123px;\n}\n\n.bracketBox {\n    // width: 208px;\n    // padding: 16px 8px;\n    // margin-bottom: 16px;\n    // border-radius: 8px;\n    // border: 1px solid #6D6D6D;\n    // background: #FFF;\n    // box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);\n    border: 1px solid #002129;\n     background: #fff;\n     box-shadow:0px 2px 2px 0px #00000060;\n      width:184px;\n      height:78px;\n      padding:10px;\n      border-radius:8px;\n      margin-bottom:2px;\n  }\n\n  .row-text {\n    margin-bottom: 8px;\n    font-size: 16px;\n  }\n\n  .bottom-text {\n    margin-top: 8px;\n    font-size: 16px;\n  }\n\n\n  .team-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n  }\n\n  .team-name {\n    flex: 1;\n    font-size: 16px;\n  }\n\n  /* Score container */\n.team-score-container {\n  flex-shrink: 0; /* Prevents the score container from stretching */\n}\n\n.team-score{\n  font-size:12px;\n}\n\n\n  /* Bracket team container */\n.bracket-team-container {\n    display: flex;\n    width: 146px;\n    align-items: center;\n    gap: var(--1, 8px);\n    border-radius: var(--1, 8px);\n    background: #FFF;\n  }\n\n  /* Team logo */\n  .team-logo-svg {\n    width: 16px;\n    height: 16px;\n    fill: #EDEDED;\n    margin-right: 10px;\n  }\n\n  /* Team seed */\n  .team-seed {\n    width: 14px;\n    height: 15px;\n    color: #002129;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin-right: 10px;\n  }\n\n  /* Team name */\n  .team-name {\n    width: 87px;\n    height: 15px;\n    color: #002129;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .no-team-name {\n    width: 135px;\n    height: 12px;\n    fill: #D9D9D9;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
